import React, { useState } from 'react'

const FaqToggle = ({ data, faqs }) => {
    const { sectionTitle } = data

    const [active, setActive] = useState(false);

    const handleToggle = (e) => {
        setActive(!active);
        const question = document.getElementById(e);
        if (!active) {
            question.classList.add("active");
        } else {
            question.classList.remove("active");
        }
    }

    return (
        <>
            {sectionTitle ? sectionTitle.map((section, index) => {

                let anchorLink = section.title
                anchorLink = anchorLink.slice(0, anchorLink.length-4).toLowerCase()

                return (
                    <section id={`${anchorLink}`} className="faq" key={index}>
                        {section.title && (
                            <h3>{section.title}</h3>
                        )}
                        { faqs ? faqs.map((faq, i) => {
                            if (faq.faqs.faqSectionName === section.title) {
                                return (
                                    <div id={`${i}`} className="faq-container" key={i}>
                                        <div className="question">
                                            <h5>{faq.title}</h5>
                                            <button 
                                                onClick={() => handleToggle(i)} 
                                                className="btn button-toggle"
                                            >
                                                +
                                            </button>
                                        </div>
                                        <div className="answer">
                                            <div dangerouslySetInnerHTML={{ __html: faq.faqs.answer }}></div>
                                        </div>
                                    </div>
                                )
                            }
                        }) : null }
                    </section>    
                )
            }) : null}
        </>
    )
}

export default FaqToggle
